import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import LoadingSpinner from "./Utilities/LoadSpinner";
import "./scss/sections/PreBookingConfirmationPage.scss";

interface PackageDetails {
  packageName: string;
  mainImageUrl: string;
  arrivalDate: string;
  departureDate: string;
  pricePerNight: string;
}

interface OrderDetails {
  orderNumber: string;
  totalPrice: number;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  customerAddress: string;
  customerCity: string;
  customerCountry: string;
  customerZipCode: string;
  packages: PackageDetails[];
}

const PreBookingConfirmationPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [orderDetails, setOrderDetails] = useState<OrderDetails | null>(null);
  const location = useLocation();

  useEffect(() => {
    const fetchOrderDetails = async (token: string) => {
      try {
        console.log("Fetching order details with token:", token);
        const response = await axios.get(
          `https://rajamaa-api-c2gghgawc8cdhwdw.westeurope-01.azurewebsites.net/api/PackageBooking/get-prebookingConfirmationDetails`,
          { params: { token } }
        );
        console.log("API response:", response.data);
        setOrderDetails(response.data as OrderDetails);
        setLoading(false);
      } catch (error) {
        console.error("API call failed:", error);
        setError("Failed to fetch order details.");
        setLoading(false);
      }
    };

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    console.log("Extracted token from URL:", token);

    if (token) {
      fetchOrderDetails(token);
    } else {
      setError("Invalid token.");
      setLoading(false);
    }
  }, [location.search]);

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        <h2>Order Confirmation</h2>
        {orderDetails && (
          <div>
            <p>Order confirmed successfully!</p>
            <p>Order Number: {orderDetails.orderNumber}</p>
            <p>Total Payment: {formatCurrency(orderDetails.totalPrice)}</p>
            <p>Customer Name: {orderDetails.customerName}</p>
            <p>Customer Email: {orderDetails.customerEmail}</p>
            <p>Customer Phone: {orderDetails.customerPhone}</p>
            <p>Customer Address: {orderDetails.customerAddress}, {orderDetails.customerCity}, {orderDetails.customerCountry}, {orderDetails.customerZipCode}</p>
        
            <h3>Package Details</h3>
            {orderDetails.packages.map((pkg, index) => (
              <div key={index} className="package-details">
                <h4>{pkg.packageName}</h4>
                <img src={pkg.mainImageUrl} alt={pkg.packageName} />
                <p>Arrival Date: {pkg.arrivalDate}</p>
                <p>Departure Date: {pkg.departureDate}</p>
                <p>Price Per Night: {formatCurrency(parseFloat(pkg.pricePerNight))}</p>
              </div>
            ))}
            <p className="closing-message">We look forward to welcoming you to Lapland!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreBookingConfirmationPage;
